export const SwipeMoreIndicator = () => {
  return (
    <idk-div
      class="zid-absolute zid-inset-x-0 zid-bottom-0 zid-flex zid-flex-col zid-items-center zid-justify-end zid-pointer-events-none zid-pb-8"
      style={{ zIndex: 9999 }}
    >
      <idk-div class="zid-mb-4">
        <svg width="60" height="60" viewBox="0 0 60 60" className="zid-animate-bounce">
          <path
            d="M30 10 L30 50 M30 50 L25 45 M30 50 L35 45"
            stroke="white"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      </idk-div>

      <idk-div
        class="zid-text-white zid-text-lg zid-font-semibold zid-bg-black zid-bg-opacity-50 zid-px-6 zid-py-3 zid-rounded-full"
        style={{ backdropFilter: 'blur(10px)' }}
      >
        swipe for more
      </idk-div>
    </idk-div>
  );
};
